module.exports = __webpack_public_path__ + "static/media/uib7.ddd66720.png";